import * as types from '../types/categoryTypes';
import { modamaiTrace } from '../../utils/modamaiTrace';

const initialState = {
  roots: [],
  loading: false,
  error: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CATEGORIES_REQUEST:
      modamaiTrace('categoryReducer FETCH_CATEGORIES_REQUEST', {});
      return { ...state, loading: true, error: null };
    case types.FETCH_CATEGORIES_SUCCESS: {
      const roots = Array.isArray(action.payload) ? action.payload : [];
      modamaiTrace('categoryReducer FETCH_CATEGORIES_SUCCESS', { rootsLen: roots.length });
      return {
        ...state,
        loading: false,
        roots,
        error: null,
      };
    }
    case types.FETCH_CATEGORIES_FAILURE:
      modamaiTrace('categoryReducer FETCH_CATEGORIES_FAILURE', action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload ?? null,
      };
    default:
      return state;
  }
};

export default categoryReducer;
